<template>
    <div class="line-form__body line-form__body--full block-wrap js-pay-container">
        <div class="line-form__check line-form__col line-form__col--agree-right">
            <h5 class="line-form__check-title" @click="myDebug">Оплата выбранных лицевых счетов и услуг</h5>
            <label class="cb-input">
                <input v-model="agree" class="cb-input__checkbox input req" type="checkbox" data-type="checkbox">
                <span class="cb-input__check"></span>
                <span class="cb-input__label"><a href="/Site/UserAgreement" target="_blank" class="link link--underline"><span class="link__text">С порядком и условиями оплаты, зачисления и возврата денежных средств согласен</span></a></span>
            </label>
            <!--<div class="line-form__check-message ex-small">
                При оплате услуг банковской картой взымается комиссия – 1% (один процент)
            </div>-->
        </div>
        <div class="line-form__payment-btns">
            <div class="line-form__double-btn-width">
                <div class="payment-drop js-cards-container">
                    <button type="button" class="button button--with-arrow button--th-second payment-drop__toggle js-cards-toggle" data-toggle="dropdown">
                        <img v-if="((PaymentMethod.substring(0,2)==='Сб') || (PaymentMethod.substring(0,2)==='Га'))" class="payment-drop__icon" v-bind:src="imageUrl(PaymentMethod)"
                             style="width:30px !important; height: 30px !important;">
                        <img v-else class="payment-drop__icon" v-bind:src="imageUrl(PaymentMethod)">
                        <span class="payment-drop__text">{{PaymentMethod}}</span>
                    </button>
                    <div class="payment-drop__drop">
                        <ul class="payment-drop__drop-inner">
                            <li class="payment-drop__item">
                                Оплатите картой любого банка
                            </li>
                            <li class="payment-drop__divider"></li>
                            <li class="payment-drop__item" @click="selectcard(-1,true)">
                                <div class="payment-drop__link js-cards-option">
                                    <img class="payment-drop__icon" src="/images/pay-types/gasprombank-icon.png"
                                         style="width:30px !important; height: 30px !important;" />
                                    <span class="payment-drop__text">Газпромбанк</span>
                                </div>
                            </li>
                            <li class="payment-drop__item" v-for="(option,index) in options" :value="option.CardId" @click="selectcard(index,true)">
                                <div class="payment-drop__link js-cards-option">
                                    <img class="payment-drop__icon" v-bind:src="option.image" style="width:35px !important;" />
                                    <span class="payment-drop__text">{{ option.MaskName }}</span>
                                    <span class="payment-drop__subtext">до <span class="status-error" v-bind:style="{color: option.color}">{{option.ExpDate}}</span></span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="amount-pay-container js-edit-payment-amount-container">
                <div v-if="isEditSum" class="line-form__amount-edit line-form__double-btn-width js-block-edit-payment-amount">
                    <input @keydown="keydown($event)"
                           @keyup="keyup($event)"
                           id="manual-sum" class="input js-edit-payment-amount-input" v-model="manSum" data-mask-max-8="" type="text" :placeholder="sumPay">
                    <button @click="iconClose" class="text-edit-trigger text-edit-trigger--remove">
                        <i class="icon icon--close"></i>
                    </button>
                </div>
                <button v-else class="button button--th-main js-btn-pay line-form__double-btn-width js-button-payment-amount"
                        :class="(agree && (manSum > 0) && isPay) ? '' : 'is-disable'"
                        v-on:click="pay">
                    Оплатить <span class="js-payment-amount-count-block">&nbsp;{{manSum}}</span> ₽
                </button>
                <!-- редактирования суммы оплаты -->
                <button v-if="isEditSum" @click='recalcSum' class="text-edit-trigger text-edit-trigger--abs text-edit-trigger--remove js-check-edit-payment-amount"><i class="icon icon--check"></i></button>
                <button v-if="!isEditSum" @click="isEditSum=true" class="text-edit-trigger text-edit-trigger--abs js-edit-payment-amount"><i class="icon icon--edit"></i></button>
            </div>

        </div>
    </div>



</template>

<script type="text/javascript">
    const W13 = 12; // Отопление.
    const W99 = 3;  // Горячая вода.
    const W139 = 2; // ХВС.
    const W149 = 1; // Водоотведение.

    export default {
        name: 'account-packet-pay',
        props: {
            adata: Array,
            cards: Array
        },
        data: function () {
            return {
                old: '',
                isPay: false,
                selectedAcc: [],
                sumPay: 0.0,
                merchCode: "FL",
                manSum: '',
                isEditSum: false,
                sumMainServOpen: 0.0,   // Сумма начислений по ОУ.
                sumMainServClosed: 0.0, // Сумма начислений по ОУ.
                sumAddServOpen: 0.0,    // Сумма начислений по ДУ.
                sumAddServClosed: 0.0,  // Сумма начислений по ДУ.
                sumWeightFactors: 0.0,  // Сумма весовых коэффициентов.
                nOpenProd: 0,           // Количество услуг в открытых счетах.
                paycard: '',
                options: [],
                agree: false,
                PaymentMethod: "Способ оплаты"
            }
        },
        //computed: {
        //    phone: function () {
        //        if (gl_phone.length == 11 && gl_phone.substring(0, 1) === "7")
        //            return "+7 (" + gl_phone.substring(1, 4) + ') '
        //                + gl_phone.substring(4, 7) + '-'
        //                + gl_phone.substring(7);
        //        return gl_phone;
        //    },
        //    email: function () {
        //        return gl_email;
        //    }
        //},
        methods: {
            //debug1: function (number) {
            //    this.selectedAcc.forEach((account) => {
            //        account.CalcData.Products.forEach((prod) => {
            //            if ((prod.Item != 13) && (prod.Item != 99)
            //                && (prod.Item != 139) && (prod.Item != 149) && (prod.SaldoEnd > 0)) {
            //            }
            //        });
            //    });
            //},
            //onKey: function (event) {
            //    var obj = document.getElementById('manual-sum');
            //    if (!((event.code.indexOf('Digit') == 0)
            //        || (event.code == 'Comma')
            //        || (event.code == "Period")
            //        || (event.code == 'NumpadDecimal')
            //        || (event.keyCode > 95 && event.keyCode < 106)))
            //        obj.value = obj.value.replaceAll(event.key, "");
            //    obj.value = obj.value.replace(",", ".");
            //    var counter = 0;
            //    for (let i = 0; i < obj.value.length; i++)
            //        if (obj.value[i] === '.') counter++;
            //    if (counter > 1) obj.value = obj.value.replace(".", "");
            //    counter = obj.value.indexOf('.');
            //    if ((counter >= 0) && (obj.value.length > (counter + 3)))
            //        obj.value = obj.value.substring(0, counter + 3);
            //},
            iconClose: function () {
                this.manSum = this.sumPay;
                this.recalcSum();
            },
            keydown: function (event) {
                this.old = event.srcElement.value;
                let key = event.key;
                switch (key) {
                    case 'ArrowLeft':
                    case 'ArrowRight':
                    case 'Delete':
                    case 'Backspace':
                        break;
                    case '.':
                        if (this.old.indexOf('.') > -1) event.preventDefault();
                        break;
                    case 'Enter':
                        event.srcElement.blur();
                        break;
                    default:
                        if (/^[0-9]$/i.test(key)) {
                            var sum = this.old.split('.');
                            if (sum[0].length > 7 && this.old.indexOf('.') == -1) {
                                event.preventDefault();
                                return;
                            }
                            if (sum[0].length > 7 && sum[1].length > 1) event.preventDefault();
                        }
                        else
                            event.preventDefault();
                        break;
                }
            },
            keyup: function (event) {
                var sum = event.srcElement.value;
                var kop = '';
                var rub = '';
                rub = sum.split('.')[0];
                if (sum.indexOf('.') > -1)
                    kop = sum.split('.')[1];
                if (rub.length > 8 || kop.length > 2)
                    event.srcElement.value = this.old;
                return;
            },
            myDebug: function () {
                var sum = 0.0;
                this.selectedAcc.forEach((account) => {
                    var accNum = account.AccountNumber;
                    account.CalcData.Products.forEach((prod) => {
                        prod.ToPayPack = Math.round(prod.ToPayPack * 100) / 100;
                        console.log('Счет', accNum, prod.ItemName, prod.Item, 'SaldoEnd', prod.SaldoEnd, 'К оплате', prod.ToPayPack);
                        sum += prod.ToPayPack;
                    });
                });
                console.log('Введено:', this.manSum, ' Сумма по услугам:', Math.round(sum * 100) / 100, '  ', this.recalcManSum());
            },
            Debt: function (saldo) {
                saldo = Number(saldo);
                return (saldo > 0.0) ? saldo : 0.0;
            },
            recalcSum: function () {
                this.isEditSum = false;
                if (this.manSum == '')
                    this.manSum = this.sumPay;
                else
                    this.manSum = Math.round(this.manSum * 100) / 100;
                var difference = this.manSum - this.sumPay;
                this.selectedAcc.forEach((account) => {
                    account.CalcData.Products.forEach((prod) => {
                        prod.ToPayPack = 0.0;
                    });
                });

                // Нет открытых счетов или нет разницы.
                if ((difference == 0.0) || ((difference > 0.0) && (this.nOpenProd == 0))) {
                    this.selectedAcc.forEach((account) => {
                        account.CalcData.Products.forEach((prod) => {
                            prod.ToPayPack = this.Debt(prod.SaldoEnd);
                        });
                    });
                    this.manSum = this.sumPay;
                    // this.debug1(1);
                    return;
                }

                // Достаточно для оплаты всех услуг.
                if (difference > 0.0) {
                    this.selectedAcc.forEach((account) => {
                        account.CalcData.Products.forEach((prod) => {
                            prod.ToPayPack = this.Debt(prod.SaldoEnd);
                        });
                    });
                    this.selectedAcc.forEach((account) => {
                        account.CalcData.Products.forEach((prod) => {
                            var sum = 0.0;
                            if (prod.open) {
                                switch (prod.Item) {
                                    case 13:
                                        sum = difference / this.sumWeightFactors * W13;
                                        break;
                                    case 99:
                                        sum = difference / this.sumWeightFactors * W99;
                                        break;
                                    case 139:
                                        sum = difference / this.sumWeightFactors * W139;
                                        break;
                                    case 149:
                                        sum = difference / this.sumWeightFactors * W149;
                                        break;
                                }
                                prod.ToPayPack += Math.floor(sum * 100) / 100;
                            }
                        });
                    });
                    // this.debug1(2);
                    // Распределение копеек.
                    var i = Math.round((this.manSum - this.recalcManSum()) * 100);
                    while (i > 0) {
                        if (i > 0) {
                            this.selectedAcc.forEach((account) => {
                                account.CalcData.Products.forEach((prod) => {
                                    if ((prod.open) && (prod.Item == 13)) {
                                        if (i-- > 0)
                                            prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                    }
                                });
                            });
                            if (i > 0) {
                                this.selectedAcc.forEach((account) => {
                                    account.CalcData.Products.forEach((prod) => {
                                        if ((prod.open) && (prod.Item == 99)) {
                                            if (i-- > 0)
                                                prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                        }
                                    });
                                });
                                if (i > 0) {
                                    this.selectedAcc.forEach((account) => {
                                        account.CalcData.Products.forEach((prod) => {
                                            if ((prod.open) && (prod.Item == 139)) {
                                                if (i-- > 0)
                                                    prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                            }
                                        });
                                    });
                                    if (i > 0) {
                                        this.selectedAcc.forEach((account) => {
                                            account.CalcData.Products.forEach((prod) => {
                                                if ((prod.open) && (prod.Item == 149)) {
                                                    if (i-- > 0)
                                                        prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                                }
                                            });
                                        });
                                    }
                                }
                            }
                        }
                    }
                    // this.debug1(3);
                    return;
                }

                // Все счета закрыты.
                if (this.nOpenProd == 0) {
                    // Недостаточно для оплаты всех услуг.
                    if (difference < 0.0) {
                        if (this.manSum < this.sumMainServClosed) { // Недостаточно для оплаты основных услуг.
                            this.selectedAcc.forEach((account) => {
                                account.CalcData.Products.forEach((prod) => {
                                    if (((prod.Item == 13) || (prod.Item == 99) || (prod.Item == 139) || (prod.Item == 149)) && prod.SaldoEnd > 0.0) {
                                        var sum = this.Debt(prod.SaldoEnd) / this.sumMainServClosed * this.manSum;
                                        prod.ToPayPack += Math.floor(sum * 100) / 100;
                                    }
                                });
                            });
                            // this.debug1(4);
                            // Распределение копеек.
                            var i = Math.round((this.manSum - this.recalcManSum()) * 100);
                            while (i > 0) {
                                if (i > 0) {
                                    this.selectedAcc.forEach((account) => {
                                        account.CalcData.Products.forEach((prod) => {
                                            if ((prod.Item == 13) && (prod.SaldoEnd > prod.ToPayPack)) {
                                                if (i-- > 0)
                                                    prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                            }
                                        });
                                    });
                                    if (i > 0) {
                                        this.selectedAcc.forEach((account) => {
                                            account.CalcData.Products.forEach((prod) => {
                                                if ((prod.Item == 99) && (prod.SaldoEnd > prod.ToPayPack)) {
                                                    if (i-- > 0)
                                                        prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                                }
                                            });
                                        });
                                        if (i > 0) {
                                            this.selectedAcc.forEach((account) => {
                                                account.CalcData.Products.forEach((prod) => {
                                                    if ((prod.Item == 139) && (prod.SaldoEnd > prod.ToPayPack)) {
                                                        if (i-- > 0)
                                                            prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                                    }
                                                });
                                            });
                                            if (i > 0) {
                                                this.selectedAcc.forEach((account) => {
                                                    account.CalcData.Products.forEach((prod) => {
                                                        if ((prod.Item == 149) && (prod.SaldoEnd > prod.ToPayPack)) {
                                                            if (i-- > 0)
                                                                prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                                        }
                                                    });
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                            // this.debug1(5);
                            return;
                        }
                        else // Остались деньги после оплаты основных услуг.
                        {
                            this.selectedAcc.forEach((account) => {
                                account.CalcData.Products.forEach((prod) => {
                                    if (((prod.Item == 13) || (prod.Item == 99) || (prod.Item == 139) || (prod.Item == 149)) && prod.SaldoEnd > 0.0) {
                                        prod.ToPayPack = prod.SaldoEnd;
                                        this.manSum -= prod.ToPayPack;
                                    }
                                });
                            });
                            this.selectedAcc.forEach((account) => {
                                account.CalcData.Products.forEach((prod) => {
                                    if ((prod.Item != 13) && (prod.Item != 99) && (prod.Item != 139) && (prod.Item != 149) && (prod.SaldoEnd > 0)) {
                                        var sum = prod.SaldoEnd / this.sumAddServClosed * this.manSum;
                                        prod.ToPayPack = Math.floor(sum * 100) / 100;
                                    }
                                });
                            });
                            // this.debug1(6);
                            // Распределение копеек.
                            var i = Math.round((this.manSum - this.recalcManSum()) * 100);
                            while (i > 0) {
                                this.selectedAcc.forEach((account) => {
                                    account.CalcData.Products.forEach((prod) => {
                                        if ((i > 0) && (prod.Item != 13) && (prod.Item != 99) && (prod.Item != 139) && (prod.Item != 149) && (prod.SaldoEnd > prod.ToPayPack)) {
                                            prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                            --i;
                                        }
                                    });
                                });
                            }
                            // this.debug1(7);
                            return;
                        }
                    }
                }

                // Есть открытые счета. Недостаточно для оплаты всех услуг.
                if ((difference < 0.0) && (this.nOpenProd > 0)) {
                    var Sum = this.manSum;
                    if (this.manSum <= (this.sumMainServClosed + this.sumMainServOpen)) { // Недостаточно для оплаты основных услуг.
                        // Распределение по ОУ закрытых счетов.
                        this.selectedAcc.forEach((account) => {
                            account.CalcData.Products.forEach((prod) => {
                                if (!prod.open) {
                                    var sum = 0.0;
                                    switch (prod.Item) {
                                        case 13:
                                            sum = this.manSum / this.sumWeightFactors * W13;
                                            break;
                                        case 99:
                                            sum = this.manSum / this.sumWeightFactors * W99;
                                            break;
                                        case 139:
                                            sum = this.manSum / this.sumWeightFactors * W139;
                                            break;
                                        case 149:
                                            sum = this.manSum / this.sumWeightFactors * W149;
                                            break;
                                    }
                                    sum = Math.floor(sum * 100) / 100;
                                    if (sum <= prod.SaldoEnd) {
                                        prod.ToPayPack = sum;
                                        Sum -= sum;
                                    }
                                    else {
                                        prod.ToPayPack = this.Debt(prod.SaldoEnd);
                                        Sum -= this.Debt(prod.SaldoEnd);
                                    }
                                }
                            });
                        });
                        // this.debug1(8);
                        // Распределение по ОУ открытых счетов.
                        this.selectedAcc.forEach((account) => {
                            account.CalcData.Products.forEach((prod) => {
                                if (prod.open) {
                                    var sum = 0.0;
                                    switch (prod.Item) {
                                        case 13:
                                            sum = Sum / this.sumWeightFactors * W13;
                                            break;
                                        case 99:
                                            sum = Sum / this.sumWeightFactors * W99;
                                            break;
                                        case 139:
                                            sum = Sum / this.sumWeightFactors * W139;
                                            break;
                                        case 149:
                                            sum = Sum / this.sumWeightFactors * W149;
                                            break;
                                    }
                                    prod.ToPayPack += Math.floor(sum * 100) / 100;
                                }
                            });
                        });
                        // this.debug1(9);
                        // Распределение копеек.
                        var i = Math.round((this.manSum - this.recalcManSum()) * 100);
                        while (i > 0) {
                            if (i > 0) {
                                this.selectedAcc.forEach((account) => {
                                    account.CalcData.Products.forEach((prod) => {
                                        if ((prod.Item == 13) && (prod.open || (prod.SaldoEnd > prod.ToPayPack))) {
                                            if (i-- > 0)
                                                prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                        }
                                    });
                                });
                                if (i > 0) {
                                    this.selectedAcc.forEach((account) => {
                                        account.CalcData.Products.forEach((prod) => {
                                            if ((prod.Item == 99) && (prod.open || (prod.SaldoEnd > prod.ToPayPack))) {
                                                if (i-- > 0)
                                                    prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                            }
                                        });
                                    });
                                    if (i > 0) {
                                        this.selectedAcc.forEach((account) => {
                                            account.CalcData.Products.forEach((prod) => {
                                                if ((prod.Item == 139) && (prod.open || (prod.SaldoEnd > prod.ToPayPack))) {
                                                    if (i-- > 0)
                                                        prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                                }
                                            });
                                        });
                                        if (i > 0) {
                                            this.selectedAcc.forEach((account) => {
                                                account.CalcData.Products.forEach((prod) => {
                                                    if ((prod.Item == 149) && (prod.open || (prod.SaldoEnd > prod.ToPayPack))) {
                                                        if (i-- > 0)
                                                            prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                                    }
                                                });
                                            });
                                        }
                                    }
                                }
                            }
                        }
                        // this.debug1(10);
                        return;
                    }
                    else // Остались деньги после оплаты основных услуг.
                    {
                        var Sum = this.manSum;
                        this.selectedAcc.forEach((account) => {
                            account.CalcData.Products.forEach((prod) => {
                                if (((prod.Item == 13) || (prod.Item == 99) || (prod.Item == 139) || (prod.Item == 149)) && prod.SaldoEnd > 0.0) {
                                    prod.ToPayPack = prod.SaldoEnd;
                                    Sum -= prod.ToPayPack;
                                }
                            });
                        });
                        this.myDebug();
                        var sumAddClosed = 0.0;
                        this.selectedAcc.forEach((account) => {
                            account.CalcData.Products.forEach((prod) => {
                                if ((!prod.open) && (prod.Item != 13) && (prod.Item != 99) && (prod.Item != 139) && (prod.Item != 149) && (prod.SaldoEnd > 0)) {
                                    if (this.sumAddServClosed > 0.0) {
                                        var sum = prod.SaldoEnd / this.sumAddServClosed * Sum;
                                        prod.ToPayPack = Math.floor(sum * 100) / 100;
                                        if (prod.ToPayPack > prod.SaldoEnd) {
                                            sumAddClosed += prod.SaldoEnd;
                                            prod.ToPayPack = prod.SaldoEnd
                                        }
                                        else
                                            sumAddClosed += prod.ToPayPack;
                                    }
                                }
                            });
                        });
                        Sum -= sumAddClosed;
                        this.selectedAcc.forEach((account) => {
                            account.CalcData.Products.forEach((prod) => {
                                if ((prod.open) && (prod.Item != 13) && (prod.Item != 99) && (prod.Item != 139) && (prod.Item != 149) && (prod.SaldoEnd > 0)) {
                                    if (this.sumAddServOpen > 0.0) {
                                        var sum = prod.SaldoEnd / this.sumAddServOpen * Sum;
                                        prod.ToPayPack = Math.floor(sum * 100) / 100;
                                    }
                                }
                            });
                        });
                        // this.debug1(11);
                        // Распределение копеек.
                        var i = Math.round((this.manSum - this.recalcManSum()) * 100);
                        console.log(i, this.manSum, this.recalcManSum());
                        while (i > 0) {
                            this.selectedAcc.forEach((account) => {
                                account.CalcData.Products.forEach((prod) => {
                                    if ((i > 0) && (prod.Item != 13) && (prod.Item != 99) && (prod.Item != 139) && (prod.Item != 149) && (prod.open || (prod.SaldoEnd > prod.ToPayPack))) {
                                        prod.ToPayPack = Math.round((prod.ToPayPack + 0.01) * 100) / 100;
                                        --i;
                                    }
                                });
                            });
                        }
                        // this.debug1(12);
                        return;
                    }
                }
            },
            recalcManSum: function () {
                var manSum = 0.0;
                this.selectedAcc.forEach((account) => {
                    account.CalcData.Products.forEach((prod) => {
                        prod.ToPayPack = Math.round(prod.ToPayPack * 100) / 100;
                        manSum += prod.ToPayPack;
                    });
                });
                return Math.round(manSum * 100) / 100;
            },
            selectcard: function (index) {
                this.isPay = true;
                if (index < 0) {
                    this.paycard = '';
                    this.PaymentMethod = "Газпромбанк";
                }
                else {
                    this.paycard = this.options[index].CardId;
                    this.PaymentMethod = this.options[index].MaskName;
                }
                return true;
            },
            addcard: function () {
                window.location = "/Profiles/AddCard/" + this.merchCode;
            },
            pay: function () {
                let order = {};
                if (this.paycard) { order.CardId = this.paycard; }
                order.BSPID = this.selectedAcc[0].BspId;
                order.Email = gl_email;
                order.Phone = gl_phone;
                order.UserId = "";
                order.Items = [];
                order.SupplierId = "";
                this.selectedAcc.forEach((account) => {
                    account.CalcData.Products.forEach((product) => {
                        let prod = {};
                        prod.Sum = product.ToPayPack;
                        if (prod.Sum > 0.0) {
                            prod.ContractId = product.ContractId;
                            prod.Item = product.Item;
                            prod.Saldo = product.SaldoEnd;
                            order.Items.push(prod);
                        }
                    });
                });
                if (order.Items.length == 0) return;
                this.agree = false;
                axios.post('/Profiles/Pay/false', order)
                    .then(function (response) {
                        var data = response.data;
                        if (data.error)
                            alert(data.error);
                        else
                            window.location = data.uri;
                    })
                    .catch(function (error) {
                        console.log(error)
                    });
                return true;
            },
            imageUrl: function (ps) {
                ps = ps.substring(0, 2);
                if (ps === 'Сп') return '';
                if (ps === 'Га') return '/images/pay-types/gasprombank-icon.png';
                if (ps === 'Сб') return '/images/pay-types/sberbank-icon.png';
                ps = ps.substring(0, 1);
                if (ps === '2') return "/images/pay-types/mir.png";
                else if (ps === '4') return "/images/pay-types/visa.png"
                else if (ps === '5') return "/images/pay-types/mastercard.png";
                else if (ps === '6') return "/images/UnionPay.png";
                return "/images/other.png";
            },
            recalcAccouns: function () {

                this.selectedAcc = [];
                this.sumPay = 0.0;
                this.manSum = '';
                this.isEditSum = false;
                this.sumMainServOpen = 0.0;   // Сумма начислений по ОУ.
                this.sumMainServClosed = 0.0; // Сумма начислений по ОУ.
                this.sumAddServOpen = 0.0;    // Сумма начислений по ДУ.
                this.sumAddServClosed = 0.0;  // Сумма начислений по ДУ.
                this.sumWeightFactors = 0.0;  // Сумма весовых коэффициентов (только открытые счета).
                this.nOpenProd = 0;           // Количество услуг в открытых счетах.
                this.adata.forEach((account) => {
                    if (account.isFlag) this.selectedAcc.push(account);
                });

                //!!! Для отладки.
                //this.selectedAcc.forEach((account) => {
                //    if (account.AccountNumber.indexOf('300') > 0)
                //        account.TerminationDate = '2023-01-01'
                //});

                this.selectedAcc.forEach((account) => {
                    account.CalcData.Products.forEach((prod) => {
                        prod.ToPayPack = this.Debt(prod.SaldoEnd);
                        this.sumPay += prod.ToPayPack;
                        prod.open = (account.TerminationDate == '')
                        this.nOpenProd += (prod.open) ? 1 : 0;
                        switch (prod.Item) {
                            case 13:
                                if (prod.open) {
                                    this.sumMainServOpen += this.Debt(prod.SaldoEnd);
                                    this.sumWeightFactors += W13;
                                }
                                else
                                    this.sumMainServClosed += this.Debt(prod.SaldoEnd);
                                break;
                            case 99:
                                if (prod.open) {
                                    this.sumMainServOpen += this.Debt(prod.SaldoEnd);
                                    this.sumWeightFactors += W99;
                                }
                                else
                                    this.sumMainServClosed += this.Debt(prod.SaldoEnd);
                                break;
                            case 139:
                                if (prod.open) {
                                    this.sumMainServOpen += this.Debt(prod.SaldoEnd);
                                    this.sumWeightFactors += W139;
                                }
                                else
                                    this.sumMainServClosed += this.Debt(prod.SaldoEnd);
                                break;
                            case 149:
                                if (prod.open) {
                                    this.sumMainServOpen += this.Debt(prod.SaldoEnd);
                                    this.sumWeightFactors += W149;
                                }
                                else
                                    this.sumMainServClosed += this.Debt(prod.SaldoEnd);
                                break;
                            default:
                                if (prod.open)
                                    this.sumAddServOpen += this.Debt(prod.SaldoEnd);
                                else
                                    this.sumAddServClosed += this.Debt(prod.SaldoEnd);
                        }
                    });
                });
                this.sumPay = Math.round(this.sumPay * 100) / 100;
                this.manSum = this.sumPay;
                this.$forceUpdate();
            }
        },
        //watch: {  // Не траслируем согласие на верхний уровень.
        //    agree: function (newCheck) {
        //        this.$emit('updateAgree', newCheck);
        //    }
        //},
        mounted() {
            this.recalcAccouns();
            for (var index in this.cards) {
                if (this.cards[index].MerchCode === "SB") continue;
                if (this.selectedAcc[0].BspId.toUpperCase() === 'KYZL') this.merchCode = "KZ";
                var year = Number('20' + this.cards[index].ExpDate.substring(0, 2));
                var mounth = Number(this.cards[index].ExpDate.substring(2, 4));
                var color = 'green';
                if (new Date() > new Date(year, mounth, 0)) color = 'red';
                if (new Date() < new Date(year, mounth - 6, 1)) color = 'inherit';
                var expDate = this.cards[index].ExpDate.substring(2) + '/' + this.cards[index].ExpDate.substring(0, 2);
                var img = this.imageUrl(this.cards[index].MaskName);
                if (this.cards[index].MerchCode === this.merchCode) {
                    let opt = {
                        CardId: this.cards[index].CardId,
                        MaskName: this.cards[index].MaskName,
                        ExpDate: expDate,
                        image: img,
                        color: color
                    };
                    this.options.push(opt);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Scripts/app/fl/components/account-packet-pay.vue